import React, { useEffect, useState } from "react";

import { Form, Row, Spinner } from "react-bootstrap";
import { GalleryAdd, GalleryEdit, ArrowLeft } from "iconsax-react";

import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { userGenders } from "../../../../libs/getConstants";
import { UserTypesAndGender } from "../../../../utility/content/UserTypesAndGender";
import { ROUTE_CHANGE_USER_PASS } from "../../../../routes";

import InputComponent from "../../../public/form/input";
import ButtonComponent from "../../../public/button";
import { Option } from "../../../../components/public/simsFilter";
import { ChangeRoleOption, ChangeInfOption } from "./changeInfOption";
import SimsFilterComponent from "../../../public/simsFilter";

import {
  FormContainer,
  ImageContainer,
  ImageProvider,
  InfoContainer,
} from "./styledUserChangeInfComponent";

export const LinkButton = ({ title, to, className }) => {
  return (
    <Row className={`justify-content-center ${className}`}>
      <ButtonComponent
        isLink={true}
        to={to}
        variant="link"
        className="change-user-pass"
      >
        {title}
        <ArrowLeft className={"mx-2"} size="24" color="var(--tertiary-color)" />
      </ButtonComponent>
    </Row>
  );
};

function UserChangeInfComponent({
  handleChangePhoto,
  handleChangeInfo,
  loading,
  imageIsLoading,
  formError,
  defaultData,
  imageUrl,
  interests,
  grades,
}) {
  const [filteredRoles, setFilteredRoles] = useState();
  const [userGender, setUserGender] = useState(defaultData?.gender);
  const genders = userGenders();
  const defaultProfile = imageUrl.includes("default-profile");

  const schema = yup.object().shape({
    first_name: yup.string().required("پر بودن این فیلد الزامی است."),
    last_name: yup.string().required("پر بودن این فیلد الزامی است."),
    nid: yup
      .string()
      .required("پر بودن این فیلد الزامی است.")
      .length(10, " کد ملی باید 10 کاراکتر باشد.")
      .matches(/[0-9]+/gi, "لطفا عدد وارد کنید."),
    gender: yup
      .object()
      .required("پر بودن این فیلد الزامی است.")
      .typeError("جنسیت خود را مشخص کنید"),
    email: yup
      .string()
      .trim()
      .required("پر بودن این فیلد الزامی است.")
      .matches(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        "این ایمیل اشتباه است."
      ),
    role: yup
      .object()
      .typeError("پر بودن این فیلد الزامی است.")
      .required("پر بودن این فیلد الزامی است."),
    school_name: yup.string().typeError("پر بودن این فیلد الزامی است."),
  });

  const imageSchema = yup.object().shape({
    img_addr: yup
      .mixed()
      .test(
        "fileSize",
        "عکس انتخاب شده باید کمتر از ۲ مگابایت باشد.",
        (value) => {
          if (!value.length) return true;
          return value[0].size <= 1024 * 1024;
        }
      ),
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
    setError,
    control,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    resolver: yupResolver(schema),
  });

  const {
    register: imageRegister,
    formState,
    formState: { errors: imageError, isValidating },
    watch,
  } = useForm({ mode: "onChange", resolver: yupResolver(imageSchema) });

  const typesDefaultValue = () => {
    const list = UserTypesAndGender.filter(
      (item) =>
        item.gender === defaultData.gender && item.type === defaultData?.type
    );
    const defaultValue = {
      label: list[0]?.title,
      value: defaultData?.type,
    };
    return defaultData?.gender !== 2 && defaultData?.type !== 0
      ? defaultValue
      : null;
  };
  const gradesDefaultValue = () => {
    const list = grades?.filter((item) => item.id === defaultData?.grade);
    const defaultValue = {
      label: list[0]?.name,
      value: list[0]?.id,
    };
    return defaultData?.grade ? defaultValue : null;
  };

  const interestDefaultValue = () => {
    let list = [];
    const allInterest = defaultData.interest.find((item) => item === 7);
    if (allInterest) {
      interests.map((item) => {
        list.push({ label: item.name, value: item.id });
      });
    } else {
      defaultData.interest.map((item, i) => {
        let temp = interests.find((element) => element.id === item);
        list.push({ label: temp.name, value: temp.id });
      });
    }
    return list;
  };

  const inputsList = [
    {
      id: 1,
      typeInput: "text",
      nameInput: "first_name",
      label: "نام",
    },
    {
      id: 2,
      typeInput: "text",
      label: "نام خانوادگی",
      nameInput: "last_name",
    },
    {
      id: 3,
      typeInput: "number",
      label: "کد ملی",
      nameInput: "nid",
    },
    {
      id: 4,
      typeInput: "select",
      nameInput: "gender",
      label: "جنسیت",
      components: ChangeInfOption,
      optionsList: Object.entries(genders).filter((item, index) => index !== 2),
      defaultValue: {
        label: genders[userGender],
        value: userGender,
      },
      isDisabled: defaultData?.gender !== 2,
    },
    {
      id: 5,
      typeInput: "text",
      label: "ایمیل",
      nameInput: "email",
    },
    {
      id: 6,
      typeInput: "select",
      nameInput: "role",
      label: "نقش کاربر",
      components: ChangeRoleOption,
      optionsList: filteredRoles,
      defaultValue: typesDefaultValue(),
      isDisabled: defaultData?.type && userGender !== 2,
    },
    {
      id: 7,
      typeInput: "select",
      nameInput: "grade",
      label: "پایه تحصیلی",
      optionsList: grades,
      components: ChangeInfOption,
      defaultValue: gradesDefaultValue(),
    },
    {
      id: 8,
      typeInput: "text",
      label: "نام مدرسه",
      nameInput: "school_name",
    },
    {
      id: 9,
      typeInput: "select",
      label: "علاقمندی‌ها",
      nameInput: "interest",
      components: Option,
      optionsList: interests,
      isMulti: true,
      defaultValue: interestDefaultValue(),
    },
  ];

  useEffect(() => {
    for (let index in defaultData) {
      switch (index) {
        case "gender":
          let data;
          userGender !== 2
            ? (data = {
                label: genders[userGender],
                value: userGender,
              })
            : (data = null);
          setValue("gender", data);
          break;
        case "type":
          setValue("role", typesDefaultValue());
          break;
        case "grade":
          if (defaultData?.grade) {
            setValue("grade", gradesDefaultValue());
          } else {
            setValue("grade", null);
          }
          break;
        case "interest":
          setValue("interest", interestDefaultValue());
          break;
        default:
          setValue(`${index}`, `${defaultData[index]}`);
          break;
      }
    }
  }, []);

  const watchData = watch();
  useEffect(() => {
    if (formState.isValid && !isValidating) {
      handleChangePhoto(watchData);
    }
  }, [isValidating]);

  useEffect(() => {
    if (userGender !== 2) {
      const filterGender = UserTypesAndGender.filter(
        (role) => role.gender == userGender
      );
      setFilteredRoles(filterGender);
    } else {
      setFilteredRoles(UserTypesAndGender);
    }
  }, [userGender]);

  useEffect(() => {
    if (formError) {
      if (formError.response.data.usermeta) {
        Object.entries(formError.response.data.usermeta).map((item) =>
          setError(item[0], { type: "test", message: item[1][0] })
        );
      }
      if (formError.response.data) {
        Object.entries(formError.response.data).map((item) =>
          setError(item[0], { type: "test", message: item[1][0] })
        );
      }
    }
  }, [formError]);

  const subjectOptions = (listOption, inputName) => {
    switch (inputName) {
      case "role":
        return listOption?.map((item) => {
          return {
            label: item.title,
            value: item.type,
            image: item.image,
          };
        });
      case "gender":
        return listOption?.map((item) => {
          return {
            label: item[1],
            value: item[0],
          };
        });
      default:
        return listOption?.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
    }
  };

  const handleSelectAll = (value) => {
    let list = [];
    value.map((item) => {
      if (item.value === 7) {
        interests.map((item) => {
          list.push({ label: item.name, value: item.id });
        });
        setValue(`interest`, list);
      }
    });
  };

  return (
    <InfoContainer className="d-flex flex-column align-items-center">
      <form>
        <ImageContainer className="pb-3">
          <ImageProvider>
            <InputComponent
              type="file"
              accept="image/png, image/jpeg,image/jpg"
              register={imageRegister("img_addr")}
              name={"img_addr"}
              disabled={imageIsLoading}
            />
            {!defaultProfile && <img src={imageUrl} alt="profile" />}

            <span>
              {defaultProfile ? (
                <GalleryAdd size="46" color="var(--text-color-muted)" />
              ) : (
                <GalleryEdit
                  size="46"
                  color="var(--white-color)"
                  className="edit-icon"
                />
              )}
            </span>
          </ImageProvider>
        </ImageContainer>
        <>
          {imageError?.img_addr && (
            <span className="text-center text-danger">
              {imageError?.img_addr?.message}
            </span>
          )}
          {imageIsLoading && (
            <span className="text-primary text-center">
              <Spinner
                as="span"
                animation="border"
                role="status"
                aria-hidden="true"
                size="sm"
              />
              &nbsp;در حال تغییر عکس
            </span>
          )}
        </>
      </form>
      <FormContainer
        className="row"
        autoComplete={"off"}
        onSubmit={handleSubmit(handleChangeInfo)}
      >
        {inputsList.map((item) => (
          <Form.Group
            className="col-12 col-lg-4 px-0 px-lg-4 mt-4"
            key={item.id}
          >
            {item.typeInput !== "select" ? (
              <InputComponent
                title={item.label}
                type={item.typeInput}
                register={register(item.nameInput)}
                defaultValue={item.defaultValue}
                containerClass={`input ${
                  errors[item.nameInput]?.message && "invalid-input"
                }`}
              />
            ) : (
              <Controller
                control={control}
                name={`${item.nameInput}`}
                render={({ field }) => {
                  const { onChange } = field;
                  return (
                    <>
                      <label htmlFor={item.nameInput}>{item.label}</label>
                      <SimsFilterComponent
                        id={item.nameInput}
                        defaultValue={item.defaultValue}
                        placeholder="انتخاب کنید."
                        options={subjectOptions(
                          item.optionsList,
                          item.nameInput
                        )}
                        components={{ Option: item.components }}
                        onChange={(val) => {
                          onChange(val);
                          if (item.nameInput === "gender") {
                            setUserGender(val.value);
                          } else if (item.nameInput === "interest") {
                            handleSelectAll(val);
                          }
                        }}
                        isSearchable={false}
                        isMulti={item.isMulti}
                        closeMenuOnSelect={item.isMulti ? false : true}
                        isDisabled={item.isDisabled}
                        className={`select ${
                          errors[item.nameInput]?.message && "invalid-input"
                        } ${item.isMulti && "wide-menu"} ${
                          item.isDisabled && "disabled"
                        }`}
                      />
                    </>
                  );
                }}
              />
            )}
            <Form.Text className="error-message">
              {errors[item.nameInput]?.message}
            </Form.Text>
          </Form.Group>
        ))}
        <Row className="p-0 mx-auto pt-5 pb-2 pb-md-4">
          <ButtonComponent
            type="submit"
            className="col-12 col-md-6 col-lg-4 mx-auto"
          >
            {loading ? (
              <Spinner
                as="span"
                animation="border"
                role="status"
                aria-hidden="true"
              ></Spinner>
            ) : (
              "ثبت اطلاعات"
            )}
          </ButtonComponent>
        </Row>
      </FormContainer>
      <LinkButton title="تغییر رمز عبور" to={ROUTE_CHANGE_USER_PASS} />
    </InfoContainer>
  );
}

export default UserChangeInfComponent;
